import React, { useEffect, useState } from 'react';
import '../../App.css';
import './ShiftCheckout.css';
import '../validate.css';
import axios from 'axios';
import { API_URL } from '../environment';
import withNavigation from '../withNavigation';
import withRouter from '../withRouter';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 


class ShiftCheckout extends React.Component {

  state = {
    bettingShop: '',
    // name: '',
    // username: '',
    isEditing: false,
    shift20: 0,
    shift50: 0,
    shift100: 0,
    shift500: 0,
    shift1000: 0,
    shift2000: 0,
    shift5000: 0,
    shiftTotal: 0,
    shiftCf20: 0,
    shiftCf50: 0,
    shiftCf100: 0,
    shiftCf500: 0,
    shiftCf1000: 0,
    shiftCf2000: 0,
    shiftCf5000: 0,
    shiftCfTotal: 0,
    expectedCloseTotal: 0,
    isShiftCreated: false,
    isShiftOpenDisabled: false,
    isFloatIncreaseDisabled: true,
    isShiftCloseDisabled: true,

    // DO TO: start shift pop up
    isAuditorPending: false,
    shiftId: '',
    shiftLogs: [],
    cashierId: '',
  }

  constructor(props) {
    super(props);
    // this.handleDenomChange = this.handleDenomChange.bind(this);
  }


  navigateToPage = (page) => {
    this.props.navigate(page);    
  }

  onClearFields = () => {
    this.setState({
      bettingShop: '',
      name: '',
      username: '',
      isEditing: false,
      shift20: 0,
      shift50: 0,
      shift100: 0,
      shift500: 0,
      shift1000: 0,
      shift2000: 0,
      shift5000: 0,
      shiftTotal: 0,
      shiftCf20: 0,
      shiftCf50: 0,
      shiftCf100: 0,
      shiftCf500: 0,
      shiftCf1000: 0,
      shiftCf2000: 0,
      shiftCf5000: 0,
      shiftCfTotal: 0,
      isShiftCreated: false,
      isShiftOpenDisabled: false,
      isFloatIncreaseDisabled: true,
      isShiftCloseDisabled: true,
    });
  };

  notify = (text = 'Text', type = 'success') => {
    toast[type](text, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 5000,
    });
  };

  showConfirmToast = (message) => {
    return new Promise((resolve) => {
      const toastId = toast(
        ({ closeToast }) => (
          <div className="w-[350px] text-center">
            <p className="text-lg font-medium mb-4">{message}</p>
            <div className="flex justify-center gap-6">
              <button
                onClick={() => {
                  toast.dismiss(toastId);
                  resolve(true);
                }}
                className="bg-green-600 hover:bg-green-700 text-black font-semibold py-2 px-4 rounded conf-btn"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  toast.dismiss(toastId);
                  resolve(false);
                }}
                className="bg-red-600 hover:bg-red-700 text-black font-semibold py-2 px-4 rounded conf-btn"
              >
                No
              </button>
            </div>
          </div>
        ),
        {
          closeOnClick: false,
          closeButton: false,
          autoClose: false,
          draggable: false,
          position: toast.POSITION.TOP_CENTER, // <== centered toast
        }
      );
    });
  };

  // async calculateExpectedClose() {
  //   const userId = localStorage.getItem("sun_userId");
  //   const params = {
  //     agentId: userId,
  //     shiftActive: true,
  //   };

  //   const response = await axios.get(`${API_URL}/shifts`, {params}); // Example API URL
  //   const currentShift = (response?.data?.length && response.data[0]) || {};
  //   const curStats = currentShift?.stats || {};
  //   const expectedEndTotal = curStats.startTotal + curStats.floatIncreaseTotal + curStats.betTotal - curStats.redeemedTotal;
  //   return expectedEndTotal;
  // }

  async componentDidMount() {
    document.body.classList.add('validate-active');
    
    // const storedUser = JSON.parse(localStorage.getItem("sun_user"));
    // const isAdmin = storedUser && storedUser.role === 'ADMIN';

    // if (isAdmin) {
    //   this.setState({roles:[
    //     {id: 'ADMIN', name: 'ADMIN'},
    //     {id: 'AGENT', name: 'AGENT'},
    //     {id: 'CASHIER', name: 'CASHIER'},
    //   ]});
    // }

    // load initial state 0f current shift
    const userId = localStorage.getItem("sun_userId");
    // const params = {
    //   agentId: userId,
    //   shiftActive: true,
    // };

    const { shiftId } = this.props.params;   // <— access it here
    // console.log("shiftId is", shiftId);      // undefined if user visited /shift-checkout

    const params = {
      _id: shiftId,
    };

    const response = await axios.get(`${API_URL}/shifts`, {params}); // Example API URL
    const currentShift = (response?.data?.length && response.data[0]) || {};

    const endDenom = currentShift.endDenom;
    const curStats = currentShift?.stats || {};
    const expectedEndTotal = curStats.startTotal + curStats.floatIncreaseTotal + curStats.betTotal - curStats.redeemedTotal;

    // load cashier data
    const agParams = {
      _id: currentShift.agentId,
    };
    const agResponse = await axios.get(`${API_URL}/agents`, {params: agParams}); // Example API URL
    const currentCashier = (agResponse?.data?.length && agResponse.data[0]) || {};
    // console.log('currentCashier', currentCashier);

    const crTickParams = {
      agentId: currentShift.agentId,
      startDate: currentShift.startedShiftAt,
      endDate: currentShift.endedShiftAt,
      exactTime: true,
    };
    const crTicketsResponse = await axios.get(`${API_URL}/tickets`, {params: crTickParams});
    let curCrTickets = (crTicketsResponse?.data?.length && crTicketsResponse.data) || [];
    curCrTickets = curCrTickets.map(o => {
      o.isCreated = true;
      o.displayValue = o.betAmount;
      o.displayText = 'Created Ticket';
      return o;
    });

    const rdmTickParams = {
      redeemedBy: currentShift.agentId,
      redeemed: true,
      startDate: currentShift.startedShiftAt,
      endDate: currentShift.endedShiftAt,
      exactTime: true,
    };

    const rdmTicketsResponse = await axios.get(`${API_URL}/tickets`, {params: rdmTickParams});
    let curRdmTickets = (rdmTicketsResponse?.data?.length && rdmTicketsResponse.data) || [];
    curRdmTickets = curRdmTickets.map(o => {
      o.isRedeemed = true;
      o.displayValue = o.payoutAmount;
      o.displayText = 'Redeemed Ticket';
      return o;
    });

    // const mergeById = (a, b) => {
    //   // Put all items from the first array into a Map keyed by `_id`
    //   const merged = new Map(a.map(item => [item._id, item]));
    
    //   // Insert / override with items from the second array
    //   b.forEach(item => merged.set(item._id, item));
    
    //   // Convert the Map’s values back to a plain array
    //   return [...merged.values()];
    // };

    const timeFormat = (inpTime) => {
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: '2-digit',
        // year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      }).format(new Date(inpTime));
    };

    let shiftTickets = curCrTickets.concat(curRdmTickets);
    shiftTickets = shiftTickets.map(o => {
      o._id = Math.random().toString();
      o.timeFormatted = timeFormat(o.createdAt);
      o.sortTime = o.createdAt;
      return o;
    });

    // console.log('shiftTickets', shiftTickets);
    let shiftLogs = shiftTickets.concat();

    // add shift opened/close attempt, add float
    shiftLogs.push({
      _id: Math.random().toString(),
      displayValue: curStats.startTotal,
      displayText: 'Shift Opened',
      timeFormatted: timeFormat(currentShift.startedShiftAt),
      sortTime: currentShift.startedShiftAt,
    });

    shiftLogs.push({
      _id: Math.random().toString(),
      displayValue: curStats.endTotal,
      displayText: 'Attempt to Close Unbalanced Shift',
      timeFormatted: timeFormat(currentShift.endedShiftAt),
      sortTime: currentShift.endedShiftAt,
    });

    // add float increases events
    const floatIncreases = currentShift.floatIncreases || [];
    for (const floatItem of floatIncreases) {
      shiftLogs.push({
        _id: Math.random().toString(),
        displayValue: floatItem.total,
        displayText: 'Float Increased',
        timeFormatted: timeFormat(floatItem.createdAt),
        sortTime: floatItem.createdAt,
      });
    }

    shiftLogs.sort((a, b) =>
      a.sortTime.localeCompare(b.sortTime, undefined, { sensitivity: 'base' })
    );

    const cashierData = {
      name: currentCashier.name,
      email: currentCashier.email,
      phoneNumber: currentCashier.phoneNumber,
      bettingShop: currentCashier?.bettingShops?.[0]?.name,
    };

    if (endDenom) {
      this.setState({
        shiftId: shiftId,
        shiftLogs: shiftLogs,
        cashierId: currentShift.agentId,
        shift20: endDenom[1] || 0,
        shift50: endDenom[5] || 0,
        shift100: endDenom[10] || 0,
        shift500: endDenom[20] || 0,
        shift1000: endDenom[50] || 0,
        shift2000: endDenom[100] || 0,
        shift5000: endDenom[5000] || 0,
        shiftCf20: endDenom[1] || 0,
        shiftCf50: endDenom[5] || 0,
        shiftCf100: endDenom[10] || 0,
        shiftCf500: endDenom[20] || 0,
        shiftCf1000: endDenom[50] || 0,
        shiftCf2000: endDenom[100] || 0,
        shiftCf5000: endDenom[5000] || 0,
        ...cashierData,
      }, () => {
        // This callback runs AFTER state is updated    
        const totalVal = this.calculateTotal();
        let shiftTotalObj = { shiftTotal: totalVal };
  
        if (totalVal >= 0) {
          shiftTotalObj = {
            ...shiftTotalObj,
            isShiftCreated: true,
            isShiftOpenDisabled: true,
            isFloatIncreaseDisabled: false,
            isShiftCloseDisabled: true,
            expectedCloseTotal: expectedEndTotal,
          };
        }
        this.setState(shiftTotalObj);
      });
    }

    // check auditedBy field
    const curUserId = localStorage.getItem("sun_userId");
    if (currentShift.auditedBy !== curUserId) {
      await axios.put(`${API_URL}/shifts`, {_id: shiftId, auditedBy: curUserId});
      await axios.post(`${API_URL}/logaction`, {
        action: 'shift_audited',
        user: curUserId,
      });
    }
    document.body.classList.add('validate-active');
  }

  componentWillUnmount() { 
    clearTimeout(this.timer);
    document.body.classList.remove('validate-active');
  }

  calculateTotal = (type = '') => {
    const totalVal = this.state[`shift${type}20`] * 1 + this.state[`shift${type}50`] * 5 + this.state[`shift${type}100`] * 10
         + this.state[`shift${type}500`] * 20 + this.state[`shift${type}1000`] * 50 + this.state[`shift${type}2000`] * 100; // + this.state[`shift${type}5000`] * 5000;
    return totalVal;
  }

  // Handle changes to the inputs
  handleDenomChange = (event) => {
    const { name, value } = event.target;
    // Extract denomination value from the name (e.g., shift20 → 20)
    const denomMatch = name.match(/\d+/); // regex to extract numbers
    const denom = denomMatch ? parseInt(denomMatch[0], 10) : null;

    let parsedVal = value;
    if (!value || value.indexOf('shift') !== -1) {
      parsedVal = 0;
      console.log('cond, ', !value || value.indexOf('shift') !== -1)
    }
    parsedVal = parseInt(parsedVal, 10);
    console.log('denom', denom, parsedVal);

    // this.setState({ [name]: value,  }); // Update the corresponding state

    let pref = 'Cf';

    this.setState({ [name]: value }, () => {
      // This callback runs AFTER state is updated    
      const totalVal = this.calculateTotal('');
      console.log('recalc', totalVal);
      this.setState({ shiftTotal: totalVal, [`shift${pref}Total`]: totalVal });
    });
  };

  handleInputChange(event) {

  };

  async approveShiftClose(event) {
    const endDenom = {
      1: parseInt(this.state.shift20, 10),
      5: parseInt(this.state.shift50, 10),
      10: parseInt(this.state.shift100, 10),
      20: parseInt(this.state.shift500, 10),
      50: parseInt(this.state.shift1000, 10),
      100: parseInt(this.state.shift2000, 10),
      5000: parseInt(this.state.shift5000, 10),
    };

    const shiftId = this.state.shiftId;
    const cashierId = this.state.cashierId;
    const closeShiftTotal = this.state.shiftTotal;

    await axios.post(`${API_URL}/approveshift`, {shiftId, cashierId, endDenom, closeShiftTotal});
    this.notify('Shift Approved');
    this.navigateToPage('/shift-review');
  };
  

  render() {    
      return <> 
      {this.state.isAuditorPending && (
        <div className="shift-pop-up">
          <h1>Your current shift is pending. Please wait for the auditor’s review.</h1>
        </div>
      )}
      <ToastContainer
        position="top-center"
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
      />
      <div className="validate">
        <div className="validate-left-shift">
          <div className="spin-border dashbord-border shift-management-title">
            <div className="spin-light spin-light-top">
              <div className="spin-light-container">
                {Array.from({ length: 15 }).map((_, index) => (
                  <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                ))}
              </div>
            </div>
            <div className="spin-number">
              <div className="spin-number__text">
                <span className="spin-number__text-big">SHIFT CHECKOUT</span> 
              </div> 
            </div>
            <div className="spin-light spin-light-bottom">
              <div className="spin-light-container">
                {Array.from({ length: 15 }).map((_, index) => (
                  <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                ))}
              </div>
            </div>
          </div>

          <div className="bet-wrap-full">


          <div className="shift-logs" >
            <button className={`btn-mrg-bottom ${this.state.isFloatIncreaseDisabled ? 'btn-blue' : 'btn-green'} ${this.state.isShiftCreated ? 'gray-out' : ''}`} >
              Shift Logs
            </button>

            <div className="shift-logs-container shift-logs-scroll">

              {this.state.shiftLogs.map((item) => (
                <div key={item._id} className="shift-logs-item">

                  <div className="shift-logs-item-text">{item.displayText} (${item.displayValue})</div>
                  <div className="shift-logs-item-data">{item.timeFormatted}</div>

                </div>
              ))}

              {/* <div className="shift-logs-item">
                <div className="shift-logs-item-text">Shift Opened ($0)</div>
                <div className="shift-logs-item-data">06.05.2025</div>
              </div>
              <div className="shift-logs-item">
                <div className="shift-logs-item-text">Created Ticket ($1000)</div>
                <div className="shift-logs-item-data">06.05.2025</div>
              </div>
              <div className="shift-logs-item">
                <div className="shift-logs-item-text">Redeemed Ticket ($700)</div>
                <div className="shift-logs-item-data">06.05.2025</div>
              </div>
              <div className="shift-logs-item">
                <div className="shift-logs-item-text">Attempt to Close Unbalanced Shift ($100)</div>
                <div className="shift-logs-item-data">06.05.2025</div>
              </div> */}

            </div>
          </div>



          <div className={`betting-form left-shifts-wrap ${!this.state.isShiftCreated ? 'gray-out' : ''}`}>
            <button className={`btn-mrg-bottom ${this.state.isFloatIncreaseDisabled ? 'btn-blue' : 'btn-green'} ${this.state.isShiftCreated ? 'gray-out' : ''}`} 
              onClick={() => { 
                this.setState({
                  isFloatIncreaseDisabled: false,
                  isShiftCloseDisabled: true,
                });
              }}>
              Close Details
            </button>
            <div className={`column ${this.state.isFloatIncreaseDisabled ? 'gray-out' : ''}`}>
            <input type="text" style={{ display: "none" }} autoComplete="shift20" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>1 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift20"
                autoComplete="off"
                value={this.state.shift20}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift20 * 1}</label>
            </div>
    
            <input type="text" style={{ display: "none" }} autoComplete="shift50" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>5 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift50"
                autoComplete="off"
                value={this.state.shift50}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift50 * 5}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shift100" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>10 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift100"
                autoComplete="off"
                value={this.state.shift100}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift100 * 10}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shift500" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>20 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift500"
                autoComplete="off"
                value={this.state.shift500}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift500 * 20}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shift1000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>50 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift1000"
                autoComplete="off"
                value={this.state.shift1000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift1000 * 50}</label>
            </div>


            <input type="text" style={{ display: "none" }} autoComplete="shift2000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>100 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift2000"
                autoComplete="off"
                value={this.state.shift2000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift2000 * 100}</label>
            </div>

            {/* <input type="text" style={{ display: "none" }} autoComplete="shift5000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>5000 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift5000"
                autoComplete="off"
                value={this.state.shift5000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift5000 * 5000}</label>
            </div> */}

            <div className="betting-form__row total-wrap">
              <label className='bet-row-lbl bet-row-left'>Total</label>
              <label className="bet-row-lbl"> = {this.state.shiftTotal}</label>
            </div>

            <div className="betting-form__row total-wrap">
              <label className='bet-row-lbl bet-row-expect-close'>Expected Close</label>
              <label className="bet-row-lbl"> = {this.state.expectedCloseTotal}</label>
            </div>

            <div className="btn-bottom-subm">
            {/* <button className="betting-form__btn btn-orange btn-mrg-bottom" onClick={() => this.handleFloatChange()}> */}
            {/* <button className="btn-orange btn-mrg-bottom" onClick={() => this.handleFloatChange()}>
                Submit Float Change
              </button> */}
            </div>

          </div>
          </div>




          <div className={`betting-form left-shifts-wrap ${!this.state.isShiftCreated ? 'gray-out' : ''}`}>

            <div className="ovr-right">
            <div className="right-btn-wrp">
              <button className={`btn-mrg-bottom ${this.state.isFloatIncreaseDisabled ? 'btn-blue' : 'btn-green'} ${this.state.isShiftCreated ? 'gray-out' : ''}`} >
                Cashier Info
              </button>
            </div>

            <div className="betting-form">
              {/* Hidden dummy input to trick autofill */}
              <input type="text" style={{ display: "none" }} autoComplete="name" />
              <input className="betting-form__input betting-form__input-width-80" placeholder='Name'
                name="name" // Name must match the state key
                autoComplete="off"
                value={this.state.name}
                onChange={this.handleInputChange} // Handle input changes
                disabled={true}
              />


              {/* Hidden dummy input to trick autofill */}
              <input type="text" style={{ display: "none" }} autoComplete="email" />
              <input className="betting-form__input betting-form__input-width-80" placeholder='Email'
                name="email" // Name must match the state key
                value={this.state.email}
                autoComplete="off"
                onChange={this.handleInputChange} // Handle input changes
                disabled={true}
              />

              {/* Hidden dummy input to trick autofill */}
              <input type="text" style={{ display: "none" }} autoComplete="phoneNumber" />
              <input className="betting-form__input betting-form__input-width-80" placeholder='Phone Number'
                name="phoneNumber" // Name must match the state key
                value={this.state.phoneNumber}
                autoComplete="off"
                onChange={this.handleInputChange} // Handle input changes
                disabled={true}
              />

              <input type="text" style={{ display: "none" }} autoComplete="bettingShop" />
              <input className="betting-form__input betting-form__input-width-80" placeholder=''
                name="bettingShop" // Name must match the state key
                value={this.state.bettingShop}
                autoComplete="off"
                disabled={true}
              />

              <div className="btn-bottom-subm">
                <button className="btn-orange btn-mrg-bottom" onClick={() => {this.approveShiftClose();}}>
                  Approve Closing Shift
                </button>
              </div>

            </div>

          </div>

          </div>


          <button className="return-menu-btn btn-yellow-shift"
              onClick={() => this.navigateToPage('/dashboard')}>RETURN TO MAIN MENU</button>

          {/* <div className="validate-right">

          </div> */}


          </div>

        </div>
      </div>
      </>;
  }
}

export default withRouter(withNavigation(ShiftCheckout));
